<div class="menu-widgets">
  <un-footer-nav heading="Products" [menus]="productsNav"></un-footer-nav>
  <!-- <un-footer-nav heading="Products" [menus]="productsNav"></un-footer-nav> -->
  <un-footer-nav heading="Resources" [menus]="resourcesNav"></un-footer-nav>
  <!-- <un-footer-nav heading="Company" [menus]="companyNav"></un-footer-nav> -->
  <un-footer-nav heading="Contact" [menus]="contactNav"></un-footer-nav>
</div>
<div class="social-menus">
  <un-locale-nav></un-locale-nav>
  <un-nav [menus]="socialNav"></un-nav>
</div>
<div class="terms-menus">
  <span i18n="@@copyright"
    >© 2020 - {{ today | date : 'yyyy' }} Univacity Ltd. All right
    reserved.</span
  >
  <un-nav [menus]="termsNav"></un-nav>
</div>
